import { SubscriptionName } from '@anm/api/modules/subscription';

const isStaffSubscription = (subscription: SubscriptionName) =>
  subscription.includes('Staff');

export default isStaffSubscription;
